import * as React from 'react';
import styles from './fact-box.scss';
import { toHex } from 'ui/common/hex-converter';
import { ComplexValue, ComponentProps } from 'ui/common';

interface FactBoxProps extends ComponentProps {
  textSavingInfo?: string;
  riskArea?: ComplexValue<number>;
}

export const FactBox = (props: FactBoxProps) => {
  const color = props.riskArea?.value && props.riskArea?.backgroundColor ? props.riskArea?.backgroundColor : undefined;
  return (
    <div>
      <div className={`${props.className} ${styles.factBox}`}>
        <div className={styles.factBoxItems} style={{ borderColor: toHex(color) }}>
          {props.children}
        </div>
      </div>
    </div>
  );
};
